<template>
  <div class="indicatorbox" :style="`width:${width};`">
      <div class="top">
            <div class="txt">
              {{topTxt}}
            </div>
            <div class="number">
              {{topNum}}
            </div>
      </div>
      <div  class="bottom" :style="`margin-top:${spacing}`">
        <div class="txt">
              {{bottomTxt}} <span>{{bottomTxtNum}}</span>
            </div>
            <div class="number" :class="state=='up'?'up':'down'">
                {{state=='up'?'增长':'下降'}} {{bottomNum}}
            </div>
      </div>   
  </div>
</template>
<script>
export default {
  name: 'indicator',
  props: {  
    width: {
      type: String,
      default: "100%"
    },
     height: {
      type: String,
      default: "100%"
    },
    state:{
      type: String,
      default: "up"
    },
    topTxt:{
      type: String,
      default: "活跃会员"
    },
    topNum:{
      type: String,
      default: "50"
    },
    bottomNum:{
      type: String,
      default: "2%"
    },
    bottomTxt:{
      type: String,
      default: "上日活跃会员"
    },
    bottomTxtNum:{
      type: String,
      default: "40"
    },
    spacing:{
        type: String,
        default: "30px"
    }
  },
  data () {  
    return {     
      
    }
  },
  methods: {
     
  },
  mounted () {
  
  }  
}
</script>
<style lang="scss">
.indicatorbox{
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  align-items:center;
  .txt{
        font-size: 14px;
        color: #C0C8FF;
        letter-spacing: 0;
        text-align: center;
          margin-bottom: 3px;
     }
  .top{
     
     .number{
       font-size: 30px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
     }
  }
  .bottom{
     .txt{
       span{
         margin-left: 10px;
       }
     }
     .number{
      font-size: 14px;     
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      color: #FFFFFF;
     }
     .number.up{
        color: #16ceb9;
     }
          .number.down{
        color: #f7517f;
     }
  }
}
</style>